





























































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import LendingAccount from "@/models/Accounts/LendingAccounts/LendingAccount";
import AccountLendingBankSettingsRead from '@/components/Accounts/LendingAccounts/Ledgers/Settings/Banking/AccountLendingBankSettingsRead.vue';
import AccountLendingCardSettingsRead from '@/components/Accounts/LendingAccounts/Ledgers/Settings/Cards/AccountLendingCardSettingsRead.vue';
import AccountGeneralPayeeSettingsRead from '@/components/Accounts/LendingAccounts/Ledgers/Settings/GeneralPayee/AccountGeneralPayeeSettingsRead.vue';
import AccountLendingInterestSettingsRead from '@/components/Accounts/LendingAccounts/Ledgers/Settings/LendingInterest/AccountLendingInterestSettingsRead.vue';
import AccountLendingScheduleSettingsRead from '@/components/Accounts/LendingAccounts/Ledgers/Settings/Schedule/AccountLendingScheduleSettingsRead.vue';
import AccountLendingRepaymentPlansSettingsRead from '@/components/Accounts/LendingAccounts/Ledgers/Settings/RepaymentPlans/AccountLendingRepaymentPlansSettingsRead.vue';
import AccountLendingTermSettingsRead from '@/components/Accounts/LendingAccounts/Ledgers/Settings/Term/AccountLendingTermSettingsRead.vue';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'LedgerSettings', components: {
    AccountLendingBankSettingsRead,
    AccountLendingCardSettingsRead,
    AccountGeneralPayeeSettingsRead,
    AccountLendingInterestSettingsRead,
    AccountLendingScheduleSettingsRead,
    AccountLendingRepaymentPlansSettingsRead,
    AccountLendingTermSettingsRead,
} })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    @Prop({required: true})
    account: LendingAccount;

    tabIndex = 0;

    get hasSettingsEnabled() {
        // Checking if at least one of the settings groups are enabled is a bit more complicated because some of the settings are still
        // behind a feature toggle so the clearest way seems to be just one big conditon, one line below for each of the settings groups
        if ((this.visibility.lendingBankSettings && this.settings.lendingBankSettings  && PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.ProductBankSettings)) ||
        (this.visibility.lendingCardSettings && this.settings.lendingCardSettings  && PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.ProductCardSettings)) ||
        (this.visibility.lendingInterestSettings && this.settings.lendingInterestSettings) ||
        (this.visibility.lendingScheduleSettings && this.settings.lendingScheduleSettings) ||
        (this.visibility.lendingRepaymentPlanSettings && this.settings.lendingRepaymentPlanSettings) ||
        (this.visibility.lendingTermSettings && this.settings.lendingTermSettings)) {
            return true;
        }
        else {
            return false;
        }
    }

    get settings() {
        return this.account.accountSettings;
    }

    get visibility() {
        return LendingAccountModule.productFeatureVisibility;
    }
}
